import { useNavigate } from 'react-router-dom';
import { useSharedUiText } from '@/shared/ui/sharedUiText';

const HISTORY_BACK_STEP = -1;

/** 目前所在的檔案已被新版本取代，頁面其他部分仍保持原樣，讓使用者決定何時重新整理 */
export function StaleAppPanel({ onGoBack }: { onGoBack?: () => void }) {
    const t = useSharedUiText();

    return (
        <div
            role="alert"
            className="mx-auto flex max-w-md flex-col items-center gap-4 rounded-box border border-warning/60 bg-warning/10 p-6 text-center"
        >
            <h2 className="text-lg font-semibold">{t('staleApp.panelTitle')}</h2>
            <div className="flex flex-wrap justify-center gap-2">
                <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={() => window.location.reload()}
                >
                    {t('refresh')}
                </button>
                {onGoBack ? (
                    <button type="button" className="btn btn-ghost btn-sm" onClick={onGoBack}>
                        {t('staleApp.goBack')}
                    </button>
                ) : null}
            </div>
        </div>
    );
}

/** 路由頁面載入失敗時顯示在版面內容區：側邊欄與頂欄不動，可返回上一頁 */
export function RouteStalePanel() {
    const navigate = useNavigate();
    return <StaleAppPanel onGoBack={() => navigate(HISTORY_BACK_STEP)} />;
}
